module.exports = __webpack_public_path__ + "img/ck-mutil-ani-star5-icon.72d72bf7.png";